import DS, { ModelSchema } from 'ember-data';
import { ActiveModelSerializer } from 'active-model-adapter';
import { ModelRegistry } from 'ember-data/model';

const { EmbeddedRecordsMixin } = DS;

export default class RecentTriggerSerializer extends ActiveModelSerializer.extend(EmbeddedRecordsMixin, {
  isNewSerializerAPI: true,
}) {
  // Use fake combined id, to store this data in the DS
  normalize(modelClass: ModelSchema<keyof ModelRegistry>, hash: Record<string, any>, prop?: string) {
    let id = hash.campaign_type;
    if (hash.object_type_id != null) {
      id += `_o:${hash.object_type_id}`;
    }
    if (hash.trigger_type != null) {
      id += `_t:${hash.trigger_type}`;
    }

    hash.id = id;

    return super.normalize(modelClass, hash, prop);
  }
}
